/*
 * @Author: lihang
 * @Date: 2020-08-05 16:00:39
 * @LastEditTime: 2020-08-05 16:01:00
 * @LastEditors: lihang
 * @Description:
 * @FilePath: \winupon-and-vue\components\_util\Dom\addEventListener.js
 */
import addDOMEventListener from 'add-dom-event-listener';

export default function addEventListenerWrap(target, eventType, cb, option) {
  return addDOMEventListener(target, eventType, cb, option);
}
